const ACTION = 'FILTER_LINKED_REMOVE';

const actionCreator = () => ({ type: ACTION });

actionCreator.ACTION = ACTION;

export default actionCreator;


// WEBPACK FOOTER //
// ./src/MerchantItems/ActionCreator/clearFilterMenuLinkedItemAction.js